import AmountTemplate from './AmountTemplate';

export default AmountTemplate;
